/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EUserType = 'Admin' | 'ServiceProvider' | 'RepairShop' | 'Customer' | 'Repairer';

export const EUserType = {
    Admin: 'Admin' as EUserType,
    ServiceProvider: 'ServiceProvider' as EUserType,
    RepairShop: 'RepairShop' as EUserType,
    Customer: 'Customer' as EUserType,
    Repairer: 'Repairer' as EUserType
};

